import React, { useEffect, useState,useRef,useContext } from 'react';
import { Link, useParams } from 'react-router-dom';
import HeaderBest from './header';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const blogData = [
  {
    id: 1,
    title: "Importers achieve savings through the First Sale rule!",
    image: "/assets/img/services_img03.png",
    tag: "Air Freight",
    date: "25 Nov, 2025",
    content: `Many importers are discovering significant cost savings by leveraging the First Sale rule — a U.S. Customs regulation that allows import duties to be calculated based on the price paid in the first sale of a multi-tiered transaction. Rather than basing duties on the final sale to the U.S. buyer, the First Sale rule lets importers declare the lower price from an earlier transaction, often between the manufacturer and a middleman. This can result in meaningful reductions in duty payments, especially when dealing with high-volume or high-value imports.
  
  To benefit from the First Sale rule, companies must meet specific criteria and maintain thorough documentation to prove the legitimacy of the transaction chain. This includes demonstrating that the first sale was a true sale, conducted at arm’s length, and clearly destined for the U.S. market. When applied correctly, the First Sale rule is a powerful tool for increasing competitiveness, improving margins, and streamlining supply chain costs — a strategic advantage that savvy importers can’t afford to overlook.`
  },
  
  {
    id: 2,
    title: "The Future of Logistics Embracing Technology",
    image: "/assets/img/h2_blog_img02.jpg",
    tag: "Warehouse",
    date: "25 Nov, 2025",
    content: `The logistics industry is undergoing a transformative shift as companies increasingly embrace advanced technologies to optimize operations and meet rising customer expectations. From AI-powered route planning and warehouse automation to real-time tracking systems and blockchain-based transparency, innovation is driving efficiency at every stage of the supply chain. These technological advancements not only reduce costs and errors but also enable faster, more reliable delivery — a key factor in today’s fast-paced, global marketplace.
  
  Looking ahead, the future of logistics lies in seamless digital integration, data-driven decision-making, and sustainable practices powered by smart technologies. As businesses adopt tools like IoT sensors, predictive analytics, and autonomous transport, they gain the agility to respond quickly to disruptions and evolving demands. Embracing technology is no longer optional — it's a strategic imperative for logistics providers aiming to stay competitive and deliver value in an increasingly interconnected world.`
  }
  ,
  {
    id: 3,
    title: "Green Logistics Solutions for a Greener Future",
    image: "/assets/img/h2_blog_img03.jpg",
    tag: "Cargo",
    date: "25 Nov, 2025",
    content: `As environmental concerns continue to grow, green logistics has emerged as a vital approach for building a more sustainable supply chain. This strategy focuses on reducing the environmental impact of logistics operations through smarter transportation, energy-efficient warehouses, eco-friendly packaging, and carbon footprint reduction. Companies that prioritize green logistics not only contribute to environmental protection but also benefit from improved brand image, regulatory compliance, and long-term cost savings.
  
  The future of logistics depends on innovation and responsibility working hand in hand. With the integration of electric vehicles, route optimization software, and renewable energy sources, businesses can significantly cut emissions while maintaining operational efficiency. Investing in green logistics is not just a trend — it’s a forward-thinking strategy that supports both planetary health and business resilience. By embracing sustainable practices today, companies are paving the way for a cleaner, greener tomorrow.`
  }
  ,
  {
    "id": 4,
    "title": "Importers achieve savings through the First Sale rule!",
    "image": "/assets/img/blog_img01.jpg",
    "tag": "Cargo",
    "date": "25 Nov, 2024",
    "content": "The First Sale Rule is a provision that allows importers to use the price paid for goods in the first sale of the product (often between the manufacturer and the wholesaler) as the basis for calculating customs duties, rather than the final sale price (the price paid to the importer). This can result in significant savings, especially when there are large markups between the first sale and the final sale.\n\nIn simple terms, instead of paying duties on the higher, final sale price, importers can use the lower first sale price, which usually results in a reduced duty rate. The savings can be substantial, making the First Sale Rule a valuable tool for importers."
  }
  ,
  {
    "id": 5,
    "title": "The Right Learning Path for Your Career",
    "image": "/assets/img/blog_img03.jpg",
    "tag": "Warehouse",
    "date": "25 Nov, 2025",
    "content": "In today’s fast-paced world, the key to professional success is continuous learning and personal development. However, with so many courses, certifications, and programs available, how do you choose the right learning path for your career? Finding the right path can make all the difference in advancing your skills, gaining industry recognition, and opening doors to new opportunities.\n\nThe right learning path for your career depends on several factors such as your goals, interests, and the industry you work in. It’s important to start by identifying your strengths and areas for improvement. For example, if you’re in the tech industry and looking to enhance your coding skills, focusing on programming languages or specific technologies might be your best route. On the other hand, if you’re in management or leadership, courses in team building, communication, and project management will be crucial."
  }
  
];

function BlogDetails() {
  const { id } = useParams();
  const blog = blogData.find(blog => blog.id === parseInt(id));
  const [email, setEmail] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState('');
  if (!blog) {
    return <div>Blog bulunamadı</div>;
  }
  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      toast.error('Please enter a valid email address');
      return;
    }

    toast.success('Email successfully subscribed!');
    setEmail('');
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return (
<>
<ToastContainer 
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        style={{
          zIndex: 9999,
          fontSize: '14px',
          width: 'auto',
          maxWidth: '400px'
        }}
      />
  {/*Preloader*/}
  <div id="preloader" style={{ display: "none" }}>
    <div className="tg-preloader-block">
      <div className="tg-spinner-eff">
        <div className="tg-bar tg-bar-top" />
        <div className="tg-bar tg-bar-right" />
        <div className="tg-bar tg-bar-bottom" />
        <div className="tg-bar tg-bar-left" />
      </div>
    </div>
  </div>
  {/*Preloader-end */}
  {/* Scroll-top */}
  <button className="scroll__top scroll-to-target open" data-target="html" onClick={scrollToTop}>
        <i className="fas fa-angle-up" />
      </button>
  {/* Scroll-top-end*/}
  {/* header-area */}
      <HeaderBest/>
  {/* header-area-end */}
  {/* main-area */}
  <main className="fix">
  {/* breadcrumb-area */}
  <section
    className="breadcrumb__area breadcrumb__bg"
    data-background="/assets/img/breadcrumb_bg.jpg"
    style={{ backgroundImage: 'url("/assets/img/breadcrumb_bg.jpg")' }}
  >
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className="breadcrumb__content">
                  <h1 className="title">Blog Detay</h1>
            <nav className="breadcrumb">
              <span property="itemListElement" typeof="ListItem">
                      <Link to="/">Ana Sayfa</Link>
              </span>
              <span className="breadcrumb-separator">
                <i className="flaticon-right-arrow" />
              </span>
              <span property="itemListElement" typeof="ListItem">
                      <Link to="/blog">Blog</Link>
                    </span>
                    <span className="breadcrumb-separator">
                      <i className="flaticon-right-arrow" />
                    </span>
                    <span property="itemListElement" typeof="ListItem">
                      {blog.title}
              </span>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* breadcrumb-area-end */}
        
  {/* blog-area */}
  <section className="blog-details-area section-py-120">
  <div className="container">
    <div className="row">
      <div className="col-lg-8">
        <div className="blog__details-wrapper">
          <div className="blog__details-thumb">
                    <img src={blog.image} alt="img" />
          </div>
          <div className="blog__details-content">
            <div className="blog__meta blog__meta-two">
              <ul className="list-wrap">
              
                <li>
                  <i className="far fa-user" /> by <a href="#">Admin</a>
                </li>
                <li>
                  <i className="flaticon-time" /> 5 Min Read
                </li>
                <li>
                  <i className="far fa-comment-alt" /> 05 Comments
                </li>
              </ul>
            </div>
                    <h3 className="title">{blog.title}</h3>
                    <p>{blog.content}</p>
                    <p>{blog.content}</p>
     
                    <div style={{backgroundColor:"red",width:"70%",margin:"auto",display:"flex",justifyContent:"center",alignItems:"center",height:4,borderRadius:50,border:"1px solid transparent",opacity:0.8,marginBottom:30,marginTop:60}}> </div>
          
            <div className="blog__details-inner-wrap">
              <div className="row">
                <div className="col-md-6">
                  <div className="blog__details-inner-img">
                    <img src="/assets/img/h2_blog_img02.jpg" alt="img" />
                    <a
                      href="http://www.youtube.com/watch?v=1iIZeIy7TqM"
                      className="play-btn popup-video"
                      style={{display: 'none'}}
                    >
                      <i className="fas fa-play" />
                    </a>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="blog__details-inner-content">
                    <h2 className="inner-title">
                      Conduct Replied Arrived Adapted
                    </h2>
                    <p>
                    The evolution of communication has always played a pivotal role in how we interact, respond, and adjust to new environments. From initial conduct to eventual adaptation, each stage reflects a dynamic process shaped by both intention and circumstance. Whether it’s through spoken word, written form, or digital exchange, the journey from sending a message to receiving a reply, arriving at an understanding, and adapting accordingly forms the core of human connection.
                    </p>
                    <div className="about__list-box about__list-box-three">
                      <ul className="list-wrap">
                        <li>
                          <i className="flaticon-check" />
                          Quality Control System
                        </li>
                        <li>
                          <i className="flaticon-check" />
                          100% Satisfaction Guarantee
                        </li>
                        <li>
                          <i className="flaticon-check" />
                          Professional and Qualified
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p>
            This continuous flow mirrors the transformation of ideas over time — much like the story of the unknown printer who redefined type with a single act of innovation. It is in these subtle transitions that meaning is both preserved and reshaped, allowing tradition and modernity to coexist. As we navigate today’s fast-paced world, these stages remind us that even the smallest gestures in communication can lead to meaningful change and adaptation.
            </p>
            <div className="blog__details-bottom" style={{display: 'none'}}>
              <div className="row align-items-center">
                <div className="col-xl-6 col-md-7">
                  <div className="tg-post-tag">
                    <h5 className="tag-title">Tags :</h5>
                    <ul className="list-wrap p-0 mb-0">
                      <li>
                                <a href="#">{blog.tag},</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-xl-6 col-md-5">
                  <div className="tg-post-social justify-content-start justify-content-md-end">
                    <h5 className="social-title">Share :</h5>
                    <ul className="list-wrap p-0 mb-0">
                      <li>
                        <a href="#">
                          <i className="fab fa-facebook-f" />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fab fa-twitter" />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fab fa-linkedin-in" />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fab fa-pinterest-p" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-4">
        <aside className="blog-sidebar">
          <div className="blog-widget widget_search">
            <div className="sidebar-search-form">
              <form action="#">
                <input type="text" placeholder="Search here" />
                <button>
                  <i className="flaticon-search" />
                </button>
              </form>
            </div>
          </div>
 
          <div className="blog-widget">
            <h4 className="widget-title">Latest Post</h4>
            <div className="rc-post-item">
              <div className="rc-post-thumb">
              <Link to="/blogdetails/1">
              <img src="/assets/img/blog_img01.jpg" alt="img" />
              </Link>
              </div>
              <div className="rc-post-content">
           
                <h4 className="title">
                  <Link to="/blogdetails/1">
                  Importers achieve savings through the First Sale rule!
                  </Link>
                </h4>
              </div>
            </div>
            <div className="rc-post-item">
              <div className="rc-post-thumb">
                <Link to="/blogdetails/3">
                  <img src="/assets/img/blog_img02.jpg" alt="img" />
                  </Link>
              </div>
              <div className="rc-post-content">
         
                <h4 className="title">
                <Link to="/blogdetails/3">
                The Growing Need Management</Link>
                </h4>
              </div>
            </div>
            <div className="rc-post-item">
              <div className="rc-post-thumb">
              <Link to="/blogdetails/5">
              <img src="/assets/img/blog_img03.jpg" alt="img" />
              </Link>
              </div>
              <div className="rc-post-content">
          
                <h4 className="title">
                <Link to="/blogdetails/5">
                    the Right Learning Path for your
                  </Link>
                </h4>
              </div>
            </div>
            <div className="rc-post-item">
              <div className="rc-post-thumb">
              <Link to="/blogdetails/1">
              <img src="/assets/img/services_img03.png" alt="img" />
              </Link>
              </div>
              <div className="rc-post-content">
             
                <h4 className="title">
                  <Link to="/blogdetails/1">Importers achieve savings through the First Sale rule!</Link>
                </h4>
              </div>
            </div>
          </div>
          <div className="blog-widget">
            <h4 className="widget-title">Tags</h4>
            <div className="tag-cloud">
                      <a >{blog.tag}</a>
            </div>
          </div>
        </aside>
      </div>
    </div>
  </div>
</section>
  {/* blog-area-end */}
</main>
  {/* main-area-end */}
  {/* footer-area */}
  <footer className="footer__area fix">
        <div className="container">
          <div className="cta__wrap fix">
            <div className="row align-items-center">
              <div className="col-lg-7">
                <div className="cta__content">
                  <h3 className="title">
                    Fastest &amp; secure way to transport <br /> anything anytime
                  </h3>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="cta__btn text-end">
                <Link to="/getoffer" className="btn btn-two">
                    Request a Quote{" "}
                    <svg
                      width={13}
                      height={13}
                      viewBox="0 0 13 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      data-inject-url="https://themeadapt.com/tf/logistex/assets/img/right_arrow.svg"
                      className="injectable"
                    >
                      <path
                        d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                        stroke="currentcolor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                        stroke="currentcolor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    </Link>
                </div>
              </div>
            </div>
            <div className="cta__shape">
              <img
                src="/assets/img/cta_shape.png"
                alt="img"
                data-aos="fade-up-right"
                data-aos-delay={400}
                className="aos-init"
              />
            </div>
          </div>
          <div className="footer__top">
            <div className="row">
              <div className="col-xl-4 col-lg-5 col-md-6">
                <div className="footer__widget">
                  <div className="footer__logo">
                  <Link to="/">
                        <img src="/assets/img/mtllogo.png" alt="Logo" />
                      </Link>
                  </div>
                  <div className="footer__content">
                    <p>
                    At MTL, we specialize in logistics solutions tailored to meet diverse delivery needs. 
                    </p>
                  </div>
                  <form onSubmit={handleSubscribe} className="footer__newsletter" style={{display: 'none'}}>
                    <div className="form-grp">
                      <input 
                        type="email" 
                        placeholder="enter your e-mail" 
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <button type="submit">Subscribe</button>
                    </div>
                    <span>We don't send you any spam</span>
                  </form>
                </div>
              </div>
              <div className="col-xl-2 col-lg-4 col-md-6 col-sm-6">
                <div className="footer__widget">
                  <h4 className="footer__widget-title">Our Services</h4>
                  <div className="footer__link">
                    <ul className="list-wrap">
                      <li>
                      <Link to="/">Home</Link>
                      </li>
                      <li>
                      <Link to="/aboutus">About Us</Link>
                      </li>
                      <li>
                      <Link to="/services">Services</Link>
                      </li>
                      <li>
                      <Link to="/blog">Blog</Link>
                      </li>
                      <li>
                      <Link to="/getoffer">Get Offer</Link>
                      </li>
                      <li>
                      <Link to="/contact">Contact</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                <div className="footer__widget">
                  <h4 className="footer__widget-title">Other Logistics Companies</h4>
                  <div className="footer__link">
                    <ul className="list-wrap">
                      <li>
                         <a href="https://mitlog.com.tr/">Mitlog Logistics</a>
                      </li>
                      <li>
                        <a href="https://www.mitlog-airsea.com.tr/">Mitlog Air&Sea Logistics</a>
                      </li>
                     
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <div className="footer__widget">
                  <h4 className="footer__widget-title">Information</h4>
                  <div className="footer__info-wrap">
                    <ul className="list-wrap">
                      <li>
                        <i className="flaticon-location-1" />
                        <p>
                        8451 Market Street ste 138, <br /> Houston Texas 77029 , USA
                        </p>
                      </li>
                      <li>
                        <i className="flaticon-telephone" />
                        <a href="tel:+18325621002">(+1) 832 562 1002</a>
                      </li>
                      <li>
                        <i className="flaticon-time" />
                        <p>
                          Mon – Fri: 8.30- 17.30 EST
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer__bottom">
            <div className="row align-items-center">
              <div className="col-md-7">
                <div className="copyright-text">
                  <p>
                    Copyright @MTL | All Right
                    Reserved
                  </p>
                </div>
              </div>
              <div className="col-md-5">
                <div className="footer__social">
                  <ul className="list-wrap">
                  <li>
                        <a href="https://wa.me/18325621002" target="_blank">
                          <i className="fab fa-whatsapp" />
                        </a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com/mtlshipinc" target="_blank">
                          <i className="fab fa-instagram" />
                        </a>
                      </li>
                
                  
                      <li>
                        <a href="https://www.linkedin.com/company/mtlship" target="_blank">
                          <i className="fab fa-linkedin-in" />
                        </a>
                      </li>
              <li/>
               
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer__shape">
          <img
            src="/assets/img/footer_shape01.png"
            alt="shape"
            data-aos="fade-down"
            data-aos-delay={400}
            className="aos-init"
          />
          <img
            src="/assets/img/footer_shape02.png"
            alt="shape"
            data-aos="fade-left"
            data-aos-delay={400}
            className="aos-init"
          />
        </div>
      </footer>
  {/* footer-area-end */}
  {/* JS here */}
    </>
  );
}

export default BlogDetails;

